import { InternalAxiosRequestConfig } from 'axios';

export const withAuth = (
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig => {
  const accessToken = localStorage.getItem('accessToken');

  // If data is FormData, do NOT set application/json
  if (!(config.data instanceof FormData)) {
    config.headers.set('Content-Type', 'application/json');
    config.headers.set('Accept', 'application/json');
  }

  if (accessToken) {
    config.headers.set('Authorization', `Bearer ${accessToken}`);
  }

  config.withCredentials = true;
  return config;
};
